/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/MailConfigBase.ts
 * @create:      2018-08-30 16:08:42.086
 * @modify:      2022-06-26 08:08:08.108
 * @version:     4.1.0
 * @times:       10
 * @lines:       70
 * @copyright:   Copyright © 2018-2022 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * @since 1.0.5
 * @version 2022-06-26
 */
export class MailConfigBase {
    public Host: string;

    public Port: number;

    public SSL: boolean;

    public User: string;

    public Password: string;

    /**
     *
     * @param host
     * @param port
     * @param ssl
     * @param user
     * @param password
     */
    public constructor(
        host: string,
        port: number,
        ssl: boolean,
        user: string,
        password: string,
    ) {
        this.Host = host;
        this.Port = port;
        this.SSL = ssl;
        this.User = user;
        this.Password = password;
    }
}
